// Initialize the event bus
  window.EventBus = window.EventBus || new EventTarget();

// // Register the listener
//   window.EventBus.addEventListener('666', (e) => {
//     console.log('✅ 收到 EventBus 事件 666，内容为：', e.detail.message);
//   });

//   Delay triggering (guaranteed that the listener is registered)
//   document.addEventListener('DOMContentLoaded', function () {
//     console.log('EventBus dispatchEvent', { EventBus: window.EventBus });
//       setTimeout(() => {
//             window.EventBus.dispatchEvent(new CustomEvent('666', {
//             detail: { message: '我是延迟触发的' }
//             }));
//         }, 100);
//   });
